export const columns: any[] = [
	{
		title: '序号',
		dataIndex: 'order',
		align: 'center',
		width: 60,
		scopedSlots: { customRender: 'order' },
	},
	{
		title: '资源公司',
		align: 'center',
		dataIndex: 'companyName',
	},
	{
		title: '简称',
		align: 'center',
		dataIndex: 'shortName',
	},
	{
		title: '作业人员人数',
		align: 'center',
		dataIndex: 'visitorNum',
	},
	{
		title: '完成数',
		align: 'center',
		dataIndex: 'finishNum',
	},
	{
		title: '完成平均时间',
		align: 'center',
		dataIndex: 'avgFinishTime',
	},
	{
		title: '延时率',
		align: 'center',
		dataIndex: 'delayRate',
		scopedSlots: { customRender: 'delayRate' },
	},
	{
		title: '审核退回率',
		align: 'center',
		dataIndex: 'backRate',
		scopedSlots: { customRender: 'backRate' },
	},
	{
		title: '超时率',
		align: 'center',
		dataIndex: 'overRate',
		scopedSlots: { customRender: 'overRate' },
	},
	{
		title: '伤者签字率',
		align: 'center',
		dataIndex: 'signRate',
		scopedSlots: { customRender: 'signRate' },
	},
	{
		title: '功能',
		align: 'center',
		dataIndex: 'action',
		scopedSlots: { customRender: 'action' },
	},
]
